import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SharedDiv from "../../Components/SharedDiv/SharedDiv";
import TransferBetweenResidentsDropDown from "../../Pages/Manager/TransferBetweenResidents/TransferBetweenResidentsDropDown";
import TransferBetweenResidentsTable from "../../Pages/Manager/TransferBetweenResidents/TransferBetweenResidentsTable";
import ButtonAHSF from "../../Components/ButtonAHSF";
import { UpdateAssigingUser } from "../../Redux/Reducers/Manager/ChangeAssigingUser";
import Swal from "sweetalert2";
import { setRefreshTable } from "../../Redux/Reducers/Shared/VariousVariables";
import { SetArrayDataCheckBoks } from "../../Redux/Reducers/Shared/CheckBox";

function TransferBetweenEvaluators() {
  const arrayDataCheckBoks = useSelector(
    (state) => state.arrayDataCheckBoks.arrayDataCheckBoks["SubtasksList"]
  );

  const [roundActive, setRoundActive] = useState(null);
  const [DropDownFrom, setDropDownFrom] = useState(null);
  const [DropDownTo, setDropDownTo] = useState(null);
  const [fields, setFields] = useState(null);
  
  const dispatch = useDispatch();
  const navigate = useNavigate();
  console.log(DropDownFrom, "dot");

  arrayDataCheckBoks?.map((item) => item.subTaskId);
  // arrayDataCheckBoks["evaluatorList"]?.map((item) => item.subTaskId);

  const ChangeEvaluator = async () => {
    dispatch(SetArrayDataCheckBoks())
    const missingFields = [];

    if (!roundActive) missingFields.push("الدورة");
    if (!fields) missingFields.push("الحقل");
    if (!DropDownFrom) missingFields.push("المقيم الحالي");
    if (!DropDownTo) missingFields.push("المقيم الجديد");
    if (!arrayDataCheckBoks || arrayDataCheckBoks.length === 0)
      missingFields.push("المهام المحددة");

    if (missingFields.length > 0) {
      Swal.fire({
        icon: "warning",
        title: "الرجاء تعبئة الحقول التالية",
        html: `
        <div style="text-align: right; direction: rtl; font-size: 16px;">
          <ul style="list-style-type: none; padding: 0;">
            ${missingFields
              .map(
                (field) =>
                  `<li style="margin-bottom: 8px;">🔸 <strong>${field}</strong></li>`
              )
              .join("")}
          </ul>
        </div>
      `,
        confirmButtonText: "حسناً",
        customClass: {
          popup: "swal2-border-radius",
        },
      });
      return;
    }

    const result = await Swal.fire({
      title: "هل انت متأكد من تحويل بين المقيمين؟",
      icon: "warning",
      confirmButtonText: "تأكيد",
      cancelButtonText: "الغاء",
      showCancelButton: true,
      showCloseButton: true,
    });

    if (result.isConfirmed) {
      try {
        await dispatch(
          UpdateAssigingUser({
            subTasksIdsList: arrayDataCheckBoks.map((item) => item.subTaskId),
            userToId: DropDownTo,
          })
        );

        Swal.fire({
          position: "center",
          icon: "success",
          title: "تم التحويل بنجاح",
          showConfirmButton: false,
          timer: 1500,
        });
        dispatch(setRefreshTable());
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "حدث خطأ أثناء التحويل",
          text: error.message || "يرجى المحاولة لاحقًا",
        });
      }
    }
  };

useEffect(()=>{
            dispatch(SetArrayDataCheckBoks())

},[])

  return (
    <>
      <SharedDiv
        showTitle={true}
        titleName="شاشة التحويل بين المقيمين"
        child={[
          <>
            <TransferBetweenResidentsDropDown
              setRoundActive={setRoundActive}
              setFields={setFields}
              setDropDownFrom={setDropDownFrom}
              DropDownFrom={DropDownFrom}
              DropDownTo={DropDownTo}
              setDropDownTo={setDropDownTo}
            />
            <TransferBetweenResidentsTable
              // roundActive={roundActive}
              fields={fields}
              DropDownFrom={DropDownFrom}
            />
          </>,
        ]}
      />
      <div className="containersButton">
        <div>
          <ButtonAHSF
            type={"submitter"}
            onClick={() => {
              ChangeEvaluator();
            }}
            disabled={false}
            text={"تحويل الطلبات"}
            show={true}
          />
        </div>
      </div>
    </>
  );
}

export default TransferBetweenEvaluators;
